'use strict';
import CampaignIcon from '@mui/icons-material/Campaign';
import CloseIcon from '@mui/icons-material/Close';
import {
  Box,
  Button,
  Divider,
  IconButton,
  Popover,
  Typography,
} from '@mui/material';
import { alpha } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';
import React from 'react';

const useStyles = makeStyles((theme) => ({
  clsButton: {
    backgroundColor: theme.palette.error.main,
    color: theme.palette.error.contrastText,
    fontWeight: theme.typography.fontWeightBold,
    letterSpacing: '0.05em',
    whiteSpace: 'nowrap',
    animation: '$pulse 1.8s ease-in-out infinite',
    '&:hover': {
      backgroundColor: theme.palette.error.dark,
    },
  },
  '@keyframes pulse': {
    '0%': {
      boxShadow: `0 0 0 0 ${alpha(theme.palette.error.main, 0.7)}`,
    },
    '70%': {
      boxShadow: `0 0 0 12px ${alpha(theme.palette.error.main, 0)}`,
    },
    '100%': {
      boxShadow: `0 0 0 0 ${alpha(theme.palette.error.main, 0)}`,
    },
  },
  clsPopover: {
    '& .MuiPopover-paper': {
      maxWidth: '42em',
      borderTop: `4px solid ${theme.palette.error.main}`,
    },
  },
  clsTitle: {
    color: theme.palette.error.main,
    flexGrow: 1,
  },
}));

const topics = [
  {
    title: 'Envio de cobranças',
    text: 'O envio de novas cobranças poderá ser realizado normalmente durante o mês de setembro. A partir do dia 01/10/2026, essa funcionalidade será suspensa.',
  },
  {
    title: 'Recebimento de pagamentos',
    text: 'As cobranças enviadas poderão ser pagas pelos seus clientes até o dia 31/10/2026.',
  },
  {
    title: 'Encerramento de cobranças pendentes',
    text: 'Em 31/10/2026, todas as cobranças não pagas serão automaticamente encerradas.',
  },
  {
    title: 'Transferência de saldo',
    text: 'Ao final do dia 31/10/2026, todo o saldo remanescente na sua conta Zeta será transferido automaticamente para a sua chave Pix cadastrada.',
  },
  {
    title: 'Exportação de relatórios',
    text: 'O acesso à plataforma ficará disponível até 31/10/2026. Recomendamos que exporte todos os relatórios e históricos necessários até essa data.',
  },
];

export default function ShutdownNotice() {
  const { clsButton, clsPopover, clsTitle } = useStyles();
  const anchorRef = React.useRef(null);
  const [isOpen, setIsOpen] = React.useState(false);

  // Abre automaticamente quando o app é aberto; o usuário pode fechar.
  React.useEffect(() => {
    setIsOpen(true);
  }, []);

  return (
    <>
      <Button
        ref={anchorRef}
        className={clsButton}
        variant="contained"
        size="large"
        startIcon={<CampaignIcon fontSize="large" />}
        onClick={() => setIsOpen(true)}
      >
        Aviso importante
      </Button>
      <Popover
        className={clsPopover}
        open={isOpen && !!anchorRef.current}
        anchorEl={anchorRef.current}
        onClose={() => setIsOpen(false)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        transformOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Box padding={3} paddingTop={2}>
          <Box display="flex" alignItems="flex-start">
            <Typography variant="h6" className={clsTitle}>
              Comunicado Importante: Encerramento das atividades da Zetaone
            </Typography>
            <IconButton
              size="small"
              aria-label="fechar"
              onClick={() => setIsOpen(false)}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </Box>
          <Box marginY={2}>
            <Divider />
          </Box>
          <Typography variant="body2" gutterBottom>
            Prezado(a) cliente,
          </Typography>
          <Typography variant="body2" gutterBottom>
            Comunicamos que a Zetaone encerrará suas atividades operacionais no
            dia <strong>01/11/2026</strong>.
          </Typography>
          <Typography variant="body2" gutterBottom>
            Para garantir uma transição pontual e organizada, solicitamos
            atenção aos prazos e regramentos abaixo:
          </Typography>
          <Box component="ul" paddingLeft={3} marginY={2}>
            {topics.map(({ title, text }) => (
              <Typography component="li" variant="body2" key={title} paragraph>
                <strong>{title}:</strong> {text}
              </Typography>
            ))}
          </Box>
          <Typography variant="body2" gutterBottom>
            Agradecemos imensamente pela parceria e pela confiança depositada em
            nosso trabalho ao longo de toda a nossa trajetória.
          </Typography>
          <Box marginTop={2}>
            <Typography variant="body2">Atenciosamente,</Typography>
            <Typography variant="body2">
              <strong>Equipe Zetaone</strong>
            </Typography>
          </Box>
        </Box>
      </Popover>
    </>
  );
}
